import { render, staticRenderFns } from "./img_list.vue?vue&type=template&id=712c8322&scoped=true&"
import script from "./img_list.vue?vue&type=script&lang=js&"
export * from "./img_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c8322",
  null
  
)

export default component.exports